import React from 'react';
import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Typography,
} from '@mui/material';
import { useGlobalization } from '@Translations';
import type { CostSource } from './useRehabActionForm';

interface CostSourceRadioProps {
	costSource: CostSource;
	onChange: (source: CostSource) => void;
	costTablesAvailable: boolean;
	noCostTablesHint?: string;
}

export const CostSourceRadio = ({
	costSource,
	onChange,
	costTablesAvailable,
	noCostTablesHint,
}: CostSourceRadioProps) => {
	const { t } = useGlobalization();

	return (
		<FormControl component="fieldset">
			<Typography variant="subtitle2">{t('Cost source')}</Typography>
			<RadioGroup
				value={costSource}
				onChange={e => onChange(e.target.value as CostSource)}>
				<FormControlLabel
					value="custom"
					control={<Radio data-cy="cost-source-custom" />}
					label={t('Enter custom cost')}
				/>
				<span
					data-testid="cost-table-radio-wrapper"
					title={noCostTablesHint}>
					<FormControlLabel
						value="costTable"
						disabled={!costTablesAvailable}
						control={<Radio data-cy="cost-source-cost-table" />}
						label={t('Use existing cost table')}
					/>
				</span>
			</RadioGroup>
		</FormControl>
	);
};
